import React from "react";
import { labels } from "../../../../localization/labels";
import ClassificationService from "../../../../services/ClassificationService";
import ClassificationTypeService from "../../../../services/ClassificationTypeService";
import {
  activeFilterPageInfo,
  trueFilter,
  activeFilter
} from "../../../../services/FilteringUtils";
import CommonUtil from "../../../../utils/CommonUtil";
import { constants } from "../../../../utils/Constants";
import ClassificationSelection from "./ClassificationSelection";
import SearchableTreeComponent from "../../page/SearchableTreeComponent";
import SecurityUtils from "../../../../utils/SecurityUtils";

class ClassificationSelectionContainer extends SearchableTreeComponent {
  constructor(props) {
    super(props);

    this.classificationTypeService = new ClassificationTypeService();
    this.classificationService = new ClassificationService();
    this.state = {
      ...this.state,
      isLoading: false,
      classificationsPageInfo: {
        filters: {
          ...activeFilter,
          fetchParents: trueFilter
        }
      }
    };
  }

  initialPageInfo() {
    var pageInfo = super.initialPageInfo();
    pageInfo.filters = {
      ...pageInfo.filters,
      classificationActive: trueFilter
    };
    return pageInfo;
  }

  initialPageSize() {
    if (this.props.initialPageSize) {
      return this.props.initialPageSize();
    }
    return super.initialPageSize();
  }

  componentDidUpdate() {
    super.componentDidUpdate();
    if (!this.state.isLoading) {
      if (this.props.entity && this.props.entity.id) {
        if (!("classifications" in this.props.entity)) {
          this.loadEntityClassifications();
        }
      } else if (
        !this.props.entity &&
        this.props.classifications !== this.state.classifications
      ) {
        this.setState({ classifications: this.props.classifications });
      }
    }
  }

  loadEntityClassifications = () => {
    this.setState({ isLoading: true });
    const url = this.props.entity._links.classifications.href;
    this.prepareCall(
      this.classificationService.getEntitiesWithParams(
        url,
        activeFilterPageInfo,
        undefined,
        this.onClassificationsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onClassificationsLoad = data => {
    const classifications = data._embedded ? data._embedded.content : [];
    this.props.setInitialEntityPropertyState("classifications", [
      ...classifications
    ]);
    this.setState({ isLoading: false, classifications });
  };

  loadRoots = pageInfo => {
    this.prepareCall(
      this.classificationTypeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onRootDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRootDataLoad = data => {
    const pageInfo = {
      ...data.page,
      filters: this.state.pageInfo.filters
    };
    if (data._embedded) {
      const content = data._embedded.content.map(item => {
        return {
          ...item,
          key: constants.TYPE_PREFIX + item.id,
          selectable: false,
          disabled: true
        };
      });

      this.setState({
        loadedKeys: [],
        content: content,
        links: data._links,
        pageInfo: pageInfo
      });
    }
  };

  onTypeDataLoad = data => {
    const treeNodeData = this.state.content.find(
      item =>
        "" + item.id ===
        CommonUtil.queryParamsGetValueForKey(
          constants.CLASSIFICATION_TYPE_ID,
          data._links.self.href
        )
    );

    this.state.loadedKeys.push(treeNodeData.key);
    if (data._embedded !== undefined) {
      const children = data._embedded.content.map(item => {
        return {
          ...item,
          key: "" + item.id,
          selectable: this.props.classificationsFilter
            ? this.props.classificationsFilter.includes(item.id)
            : true,
          disabled: false,
          classModelEnabled:
            treeNodeData.id === constants.CLASSIFICATION_TYPE_ENABLE_CLASS_MODEL
        };
      });
      treeNodeData.children = children;
    } else {
      treeNodeData.children = undefined;
      treeNodeData.leaf = true;
    }
    this.setState({
      loadedKeys: this.state.loadedKeys,
      content: [...this.state.content]
    });
  };

  loadDataByType = type => {
    this.prepareCall(
      this.classificationService.getClassificationsByType(
        type,
        this.onTypeDataLoad,
        this.messageHandler.handleError,
        this.state.classificationsPageInfo
      )
    );
    return this.performCalls();
  };

  loadDataByParent = parent => {
    this.prepareCall(
      this.classificationService.getClassificationsChildren(
        parent,
        this.onDataLoad,
        this.messageHandler.handleError,
        this.state.classificationsPageInfo
      )
    );
    return this.performCalls();
  };

  loadData = expanded => {
    if (expanded.disabled) {
      return this.loadDataByType(expanded);
    } else {
      return this.loadDataByParent(expanded);
    }
  };

  checkNodeCallback = (item, data) => {
    return (
      !item.key.startsWith(constants.TYPE_PREFIX) &&
      "" + item.id ===
        CommonUtil.queryParamsGetValueForKey(
          constants.CLASSIFICATION_PARENT_ID,
          data._links.self.href
        )
    );
  };

  removeDisabledParentsFromTree = tree => {
    let children = [];
    if (tree && tree.length > 0) {
      tree.forEach(element => {
        if (!element.disabled) {
          children.push(element);
        }
        if (element.children && element.children.length > 0) {
          children = children.concat(element.children);
        }
      });
    }
    return children;
  };

  loadEntitiesWithFilter = pageInfo => {
    this.loadClassificationsWithFilter(pageInfo);
  };

  loadClassificationsWithFilter = pageInfo => {
    this.prepareCall(
      this.classificationService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onLoadWithFilter,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLoadWithFilter = data => {
    const pageInfo = data.page;
    pageInfo.filters = this.state.pageInfo.filters;
    let content = [];
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      content = dataContent.map(item => {
        return {
          ...item,
          key: "" + item.id,
          selectable: this.props.classificationsFilter
            ? this.props.classificationsFilter.includes(item.id)
            : true,
          leaf: true
        };
      });
    }
    this.setState({
      loadedKeys: [],
      content: content,
      links: data._links,
      pageInfo: pageInfo
    });
  };

  onItemClick = key => {
    const items = this.state.content;
    const childrenItems = this.removeDisabledParentsFromTree(items);
    const item = CommonUtil.findItemInTreeById(childrenItems, parseInt(key));
    if (item) {
      const { id, name } = item;
      const classifications = this.state.classifications
        ? this.state.classifications
        : [];
      const existingClassification = classifications.find(
        item => item.id === id
      );
      if (!existingClassification) {
        classifications.push({ id, name });
        this.setState({
          classifications: classifications
        });
        this.props.setClassificationsOnEntity(classifications);

        this.messageHandler.handleSuccess({
          text: labels.classification + " " + name + " " + labels.isAdded
        });
      } else {
        this.messageHandler.handleWarning({
          text:
            labels.classification + " " + name + " " + labels.isAlreadySelected
        });
      }
    }
  };

  removeData = event => {
    const targetId = event.currentTarget.id;
    const classificationId = parseInt(targetId);
    const classifications = this.state.classifications;
    const index = classifications
      .map(item => item.id)
      .indexOf(classificationId);
    const classificationName = classifications[index].name;
    classifications.splice(index, 1);
    this.setState({
      classifications: classifications
    });
    this.props.setClassificationsOnEntity(classifications);
    this.messageHandler.handleWarning({
      text:
        labels.classification +
        " " +
        classificationName +
        " " +
        labels.isRemoved
    });
  };

  render() {
    return (
      <ClassificationSelection
        {...this.renderProps()}
        onItemClick={this.onItemClick}
        classifications={this.state.classifications}
        removeData={this.removeData}
        readOnly={this.props.readOnly}
        classificationsFilter={this.props.classificationsFilter}
      />
    );
  }
}

export default ClassificationSelectionContainer;
